import { IfNewOrders } from '../../interfaces/ifNewOrders'
import { ActionContextBasic } from '../index'
import { Snack, SnackType } from '@/interfaces/snack'

export interface State {
  snacks: Snack[];
  ifNewOrders: {
    order: boolean;
    refund: boolean;
    refundAudit: boolean;
    refundApplication: boolean;
  };
}

const state = () => ({
  snacks: [],
  ifNewOrders: {
    order: false,
    refund: false,
    refundAudit: false,
    refundApplication: false
  }
})

const mutations = {
  INSERT_MSG (state: State, msg: Snack) {
    state.snacks.push(msg)
  },
  REMOVE_MSG (state: State, resIndex: number) {
    const leftSnacks = state.snacks.concat()
    leftSnacks.splice(resIndex, 1)
    state.snacks = leftSnacks
  },
  UPDATE_IF_NEW_ORDERS (state: State, obj: IfNewOrders) {
    state.ifNewOrders = Object.assign({}, state.ifNewOrders, obj)
  }
}

const actions = {
  showSnack: (context: ActionContextBasic, msg: Snack) => {
    let duration = 2000
    switch (msg.type) {
      case SnackType.Error:
        duration = 2000
        break
      case SnackType.Success:
      default:
        duration = 1000
        break
    }
    context.commit('INSERT_MSG', msg)
    setTimeout(() => {
      context.commit('REMOVE_MSG', 0)
    }, duration)
  },
  updateIfNewOrders: (context: ActionContextBasic, obj: IfNewOrders) => {
    context.commit('UPDATE_IF_NEW_ORDERS', obj)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
